import { render, staticRenderFns } from "./BlocEnfantTemplate.vue?vue&type=template&id=0710b366&scoped=true&"
import script from "./BlocEnfantTemplate.vue?vue&type=script&lang=ts&"
export * from "./BlocEnfantTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./BlocEnfantTemplate.vue?vue&type=style&index=0&id=0710b366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0710b366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
